interface LocalUser {
  id: string;
  email: string;
  name: string;
  client_id: string;
  role: string;
  isDemo?: boolean;
}

export function getLocalUser(): LocalUser | null {
  const saved = localStorage.getItem('user');
  if (!saved) return null;
  try {
    return JSON.parse(saved);
  } catch {
    return null;
  }
}
